// jshint esversion: 8

export default {
  SET_DATA: (state, payload) => state.data = payload,
  CLEAR_DATA: (state) => state.data = [],
  SET_STOPS_BY_TRIP_MAP: (state, payload) => state.stopsByTripMap = payload 
};
